import { computed, ref } from 'vue';
import { post } from '@utils/api';
import { usePageData } from '@composables/usePageData';
import { useUser } from '@composables/user/useUser';
import { useEnvProps } from '@composables/useEnvProps';
import { buildUrl, getContextParams } from '../../../utils/commonUtils';
import {
  COMMENT_SUBMIT_SUCCESS_MSG, COMMENT_GENERIC_ERROR,
} from '../constants';
/**
 *
 * @param {Review} review
 * @returns
 */
export const useReviewComments = (review) => {
  const { hostlink } = useEnvProps();
  const {
    shoppingMode, regionCode, currencyCode, customerState, deviceType,
  } = usePageData();

  const { userId } = useUser();

  const context = {
    shoppingMode,
    regionCode,
    currencyCode,
    customerState,
    deviceType,
  };

  const contextParams = getContextParams(context);

  const commentApiUrl = buildUrl(`${hostlink}/xapi/digital/v1/product/review/commentsubmit`, contextParams);

  /**
   * @type {import('vue').Ref<string>}
   */
  const commentText = ref('');
  /**
   * @type {import('vue').Ref<string>}
   */
  const nickName = ref('');

  /**
   * @type {import('vue').Ref<string>}
   */
  const emailAddresss = ref('');

  /**
   * Reactive state for tracking submission status.
   * @type {import('vue').Ref<{failureGeneric: boolean, success: boolean}>}
   */

  const submitStatus = ref({
    failureGeneric: false,
    success: false,
  });

  const isSubmitEnabled = computed(() => !!(commentText.value?.length && nickName.value?.length >= 1));

  /**
 * Computed property for handling data on post submit
 * @type {import('vue').ComputedRef<{
 *   commentSubmit: {
 *     reviewId: number,
 *     userNickname: string,
 *     commentText: string,
 *     userId: string
 *   }
 * }>}
 */
  const commentData = computed(() => ({
    commentSubmit: {
      reviewId: review.reviewId,
      userNickname: nickName.value,
      commentText: commentText.value,
      userId,
    },
  }));

  const headers = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  // TODO refactor using form managing lib
  const clearFormAndErrorValues = () => {
    [nickName, commentText].forEach((item) => {
      item.value = '';
    });
    // TODO revist should success = null instead of false?
    Object.keys(submitStatus.value).forEach((key) => {
      submitStatus.value[key] = false;
    });
  };

  const notificationType = computed(() => (submitStatus.value.success ? 'success' : 'error'));

  const notificationMsg = computed(() => (submitStatus.value.success ? COMMENT_SUBMIT_SUCCESS_MSG : COMMENT_GENERIC_ERROR));

  const submitReviewComment = async () => {
    try {
      const response = await post(commentApiUrl, commentData.value, headers);
      const errorStatus = response?.commentSubmit?.hasErrors;

      if (errorStatus) {
        submitStatus.value.failureGeneric = true;
      } else {
        submitStatus.value.success = true;
      }
    } catch (e) {
      submitStatus.value.failureGeneric = true;
      console.warn(e); /* eslint-disable-line */
    }
  };

  return {
    commentText,
    nickName,
    emailAddresss,
    submitReviewComment,
    clearFormAndErrorValues,
    submitStatus,
    isSubmitEnabled,
    notificationType,
    notificationMsg,
  };
};

export default useReviewComments;
